import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useActiveProject } from '../../context/ActiveProjectContext';
import {
  isClientPathAllowedWithoutProject,
  parseProjectIdFromPath,
} from '../../utils/deepLink';

/**
 * Forces Jira-style project selection: clients must pick a project before app routes.
 */
export default function ClientProjectGate({ children }) {
  const location = useLocation();
  const { projects, activeProjectId, setActiveProject, loading } = useActiveProject();
  const routeProjectId = parseProjectIdFromPath(location.pathname);

  useEffect(() => {
    if (routeProjectId && routeProjectId !== activeProjectId) {
      setActiveProject(routeProjectId);
    }
  }, [routeProjectId, activeProjectId, setActiveProject]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (location.pathname === '/app/projects') {
    if (projects.length === 1) {
      return <Navigate to={`/app/projects/${projects[0].id}`} replace />;
    }
    return children;
  }

  if (isClientPathAllowedWithoutProject(location.pathname)) {
    return children;
  }

  if (routeProjectId) {
    return children;
  }

  if (activeProjectId) {
    return <Navigate to={`/app/projects/${activeProjectId}`} replace />;
  }

  if (projects.length === 1) {
    return <Navigate to={`/app/projects/${projects[0].id}`} replace />;
  }

  return <Navigate to="/app/projects" replace />;
}
